import React, { useCallback, useEffect, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { SlideOne } from './components/SlideOne';
import { SlideTwo } from './components/SlideTwo';
import { ChevronLeft, ChevronRight } from 'lucide-react';
export function App() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 2;
  const nextSlide = useCallback(() => {
    setCurrentSlide(prev => Math.min(prev + 1, totalSlides - 1));
  }, []);
  const prevSlide = useCallback(() => {
    setCurrentSlide(prev => Math.max(prev - 1, 0));
  }, []);
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'ArrowRight' || e.key === 'Space' || e.key === 'Enter') {
        nextSlide();
      } else if (e.key === 'ArrowLeft') {
        prevSlide();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [nextSlide, prevSlide]);
  return <div className="relative w-screen h-screen bg-apple-bg text-apple-text overflow-hidden font-sans selection:bg-apple-accent/30 selection:text-apple-accent" data-id="element-0">
      <div className="w-full h-full relative" data-id="element-1">
        <AnimatePresence mode="wait" data-id="element-2">
          {currentSlide === 0 && <SlideOne key="slide1" data-id="element-3" />}
          {currentSlide === 1 && <SlideTwo key="slide2" data-id="element-4" />}
        </AnimatePresence>
      </div>

      <div className="absolute top-0 left-0 w-1/4 h-full z-10 cursor-w-resize" onClick={prevSlide} title="Previous Slide" data-id="element-5" />
      <div className="absolute top-0 right-0 w-1/4 h-full z-10 cursor-e-resize" onClick={nextSlide} title="Next Slide" data-id="element-6" />

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-4 z-20 opacity-30 hover:opacity-100 transition-opacity duration-300" data-id="element-7">
        <button onClick={prevSlide} disabled={currentSlide === 0} className="p-2 rounded-full hover:bg-black/5 disabled:opacity-30 disabled:hover:bg-transparent transition-colors" data-id="element-8">
          <ChevronLeft size={20} data-id="element-9" />
        </button>

        <div className="flex gap-2" data-id="element-10">
          {[...Array(totalSlides)].map((_, i) => <div key={i} className={`w-2 h-2 rounded-full transition-colors duration-300 ${i === currentSlide ? 'bg-apple-accent' : 'bg-black/15'}`} data-id="element-11" />)}
        </div>

        <button onClick={nextSlide} disabled={currentSlide === totalSlides - 1} className="p-2 rounded-full hover:bg-black/5 disabled:opacity-30 disabled:hover:bg-transparent transition-colors" data-id="element-12">
          <ChevronRight size={20} data-id="element-13" />
        </button>
      </div>
    </div>;
}